import { render } from "./NavbarBrand.vue?vue&type=template&id=61871a90"
import script from "./NavbarBrand.vue?vue&type=script&lang=js"
export * from "./NavbarBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Navigation/NavbarBrand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61871a90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61871a90', __exports__)) {
    api.reload('61871a90', __exports__)
  }
  
  module.hot.accept("./NavbarBrand.vue?vue&type=template&id=61871a90", () => {
    api.rerender('61871a90', render)
  })

}


export default __exports__